import { render, staticRenderFns } from "./MicroserviceObjectForm.vue?vue&type=template&id=9fea0f38&scoped=true&lang=pug&"
import script from "./MicroserviceObjectForm.vue?vue&type=script&lang=js&"
export * from "./MicroserviceObjectForm.vue?vue&type=script&lang=js&"
import style0 from "./MicroserviceObjectForm.vue?vue&type=style&index=0&id=9fea0f38&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fea0f38",
  null
  
)

/* custom blocks */
import block0 from "./MicroserviceObjectForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports